import { AccordionDetails, AccordionSummary, Box, Skeleton } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { StyledServiceAccountAccordion } from './ServiceAccountCard';

export const ServiceAccountLoadingSkeleton = () => {
  return (
    <StyledServiceAccountAccordion defaultExpanded={true} disabled>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Skeleton variant='text' width={200} height={32} />
      </AccordionSummary>
      <AccordionDetails>
        <Skeleton variant='rectangular' width='100%' height={48} sx={{ mb: 3, borderRadius: 1 }} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 1.5,
            paddingBottom: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant='text' width={100} height={24} />
          <Skeleton variant='text' width='60%' height={24} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 1.5,
            paddingBottom: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant='text' width={100} height={24} />
          <Skeleton variant='text' width='70%' height={24} />
        </Box>

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingTop: 1.5,
            paddingBottom: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
          }}
        >
          <Skeleton variant='text' width={100} height={24} />
          <Skeleton variant='text' width='50%' height={24} />
        </Box>

        <Box sx={{ marginTop: 3, textAlign: 'right' }}>
          <Skeleton variant='rectangular' width={100} height={36} sx={{ marginLeft: 'auto', borderRadius: 1 }} />
        </Box>
      </AccordionDetails>
    </StyledServiceAccountAccordion>
  );
};
